// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.loading {
  position: relative;
  display: flex;
  align-items: center;
  flex-direction: column;
  justify-content: center;
}
.loading--label-leading {
  text-align: inherit;
  align-items: flex-start;
}
.loading__text, .loading__text--fade-out {
  opacity: 0;
}
.loading__text {
  max-width: 100%;
  font-size: 1rem;
  line-height: 1.625;
  margin-top: 2.5rem;
  text-align: center;
  transform: translateY(1.5rem);
}
.loading__text--fade-out {
  transition: transform 100ms cubic-bezier(0.4, 0, 0.4, 1), opacity 100ms cubic-bezier(0.4, 0, 0.4, 1);
  transform: translateY(-1.5rem);
}
.loading__text--fade-in {
  transition: transform 100ms cubic-bezier(0.4, 0, 0.4, 1), opacity 100ms cubic-bezier(0.4, 0, 0.4, 1);
  transform: translateY(0);
  opacity: 1;
}
.loading__ball {
  display: block;
  width: 0;
  height: 0;
  transform-origin: bottom;
  border-radius: 64px;
  border: 0.5rem solid rgb(var(--colour-semantic-informative, 0, 88, 163));
  transition: opacity 200ms cubic-bezier(0.4, 0, 0.4, 1);
  animation: loading-bounce 0.7s infinite;
}
.loading__ball--small {
  border-width: 0.125rem;
}
.loading__ball--medium {
  border-width: 0.25rem;
}
.loading__ball--small, .loading__ball--medium {
  transform: translateY(-160%);
  animation: loading-bounce-small 0.7s infinite;
}
.loading__ball--large {
  margin-bottom: 2rem;
}
.loading__ball--primary {
  border-color: rgb(var(--colour-neutral-7, 17, 17, 17));
}
.loading__ball--secondary {
  border-color: rgb(var(--colour-neutral-1, 255, 255, 255));
}
.loading__ball--secondary + .loading__text {
  color: rgb(var(--colour-text-and-icon-5, 255, 255, 255));
}
.loading__linear-wrapper {
  position: relative;
  display: flex;
  width: 100%;
  height: 0.3125rem;
}
.loading__linear-wrapper + .loading__text {
  margin-top: 1rem;
}
.loading__sr-only-text, .loading__linear-label {
  position: absolute;
  height: 1px;
  width: 1px;
  overflow: hidden;
  clip: rect(1px, 1px, 1px, 1px);
  margin: -1px;
  white-space: nowrap;
}
.loading__linear-progress {
  -webkit-appearance: none;
  appearance: none;
  width: 100%;
  height: 100%;
  border: 0;
  border-radius: 0.375rem;
  background: rgb(var(--colour-neutral-2, 245, 245, 245));
}
.loading__linear-progress::-webkit-progress-bar {
  border-radius: 0.375rem;
  background: rgb(var(--colour-neutral-2, 245, 245, 245));
}
.loading__linear-progress::-moz-progress-bar {
  border-radius: 0.375rem;
  background: rgb(var(--colour-semantic-informative, 0, 88, 163));
}
.loading__linear-progress::-webkit-progress-value {
  border-radius: 0.375rem;
  background: rgb(var(--colour-semantic-informative, 0, 88, 163));
}
@media (forced-colors: active) {
  .loading__linear-progress {
    appearance: revert;
    height: revert;
    border: revert;
    border-radius: revert;
    background: revert;
  }
}

@media (prefers-reduced-motion: reduce) {
  .loading .loading__text {
    transition: none;
  }
  .loading .loading__ball {
    transition: none;
  }
}
@keyframes loading-bounce-small {
  0%, 100% {
    transform: translate(0, -160%);
    animation-timing-function: cubic-bezier(0.42, 0, 1, 1);
  }
  40% {
    transform: translate(0, 20%);
    animation-timing-function: cubic-bezier(0, 0, 0, 1);
  }
}
@keyframes loading-bounce {
  0% {
    transform: translateY(0);
    animation-timing-function: cubic-bezier(0.42, 0, 1, 1);
  }
  40% {
    transform: translateY(2rem) scaleY(1);
    animation-timing-function: ease-in;
  }
  50% {
    transform: translateY(2rem) scaleY(0.75);
    animation-timing-function: ease-out;
  }
  60% {
    transform: translateY(2rem) scaleY(1);
    animation-timing-function: cubic-bezier(0, 0, 0, 1);
  }
  100% {
    transform: translateY(0);
  }
}`, "",{"version":3,"sources":["webpack://./node_modules/@ingka/loading/dist/style.css"],"names":[],"mappings":"AAAA;EACE,kBAAkB;EAClB,aAAa;EACb,mBAAmB;EACnB,sBAAsB;EACtB,uBAAuB;AACzB;AACA;EACE,mBAAmB;EACnB,uBAAuB;AACzB;AACA;EACE,UAAU;AACZ;AACA;EACE,eAAe;EACf,eAAe;EACf,kBAAkB;EAClB,kBAAkB;EAClB,kBAAkB;EAClB,6BAA6B;AAC/B;AACA;EACE,oGAAoG;EACpG,8BAA8B;AAChC;AACA;EACE,oGAAoG;EACpG,wBAAwB;EACxB,UAAU;AACZ;AACA;EACE,cAAc;EACd,QAAQ;EACR,SAAS;EACT,wBAAwB;EACxB,mBAAmB;EACnB,wEAAwE;EACxE,sDAAsD;EACtD,uCAAuC;AACzC;AACA;EACE,sBAAsB;AACxB;AACA;EACE,qBAAqB;AACvB;AACA;EACE,4BAA4B;EAC5B,6CAA6C;AAC/C;AACA;EACE,mBAAmB;AACrB;AACA;EACE,sDAAsD;AACxD;AACA;EACE,yDAAyD;AAC3D;AACA;EACE,wDAAwD;AAC1D;AACA;EACE,kBAAkB;EAClB,aAAa;EACb,WAAW;EACX,iBAAiB;AACnB;AACA;EACE,gBAAgB;AAClB;AACA;EACE,kBAAkB;EAClB,WAAW;EACX,UAAU;EACV,gBAAgB;EAChB,8BAA8B;EAC9B,YAAY;EACZ,mBAAmB;AACrB;AACA;EACE,wBAAwB;EACxB,gBAAgB;EAChB,WAAW;EACX,YAAY;EACZ,SAAS;EACT,uBAAuB;EACvB,uDAAuD;AACzD;AACA;EACE,uBAAuB;EACvB,uDAAuD;AACzD;AACA;EACE,uBAAuB;EACvB,+DAA+D;AACjE;AACA;EACE,uBAAuB;EACvB,+DAA+D;AACjE;AACA;EACE;IACE,kBAAkB;IAClB,cAAc;IACd,cAAc;IACd,qBAAqB;IACrB,kBAAkB;EACpB;AACF;;AAEA;EACE;IACE,gBAAgB;EAClB;EACA;IACE,gBAAgB;EAClB;AACF;AACA;EACE;IACE,8BAA8B;IAC9B,sDAAsD;EACxD;EACA;IACE,4BAA4B;IAC5B,mDAAmD;EACrD;AACF;AACA;EACE;IACE,wBAAwB;IACxB,sDAAsD;EACxD;EACA;IACE,qCAAqC;IACrC,kCAAkC;EACpC;EACA;IACE,wCAAwC;IACxC,mCAAmC;EACrC;EACA;IACE,qCAAqC;IACrC,mDAAmD;EACrD;EACA;IACE,wBAAwB;EAC1B;AACF","sourcesContent":[".loading {\n  position: relative;\n  display: flex;\n  align-items: center;\n  flex-direction: column;\n  justify-content: center;\n}\n.loading--label-leading {\n  text-align: inherit;\n  align-items: flex-start;\n}\n.loading__text, .loading__text--fade-out {\n  opacity: 0;\n}\n.loading__text {\n  max-width: 100%;\n  font-size: 1rem;\n  line-height: 1.625;\n  margin-top: 2.5rem;\n  text-align: center;\n  transform: translateY(1.5rem);\n}\n.loading__text--fade-out {\n  transition: transform 100ms cubic-bezier(0.4, 0, 0.4, 1), opacity 100ms cubic-bezier(0.4, 0, 0.4, 1);\n  transform: translateY(-1.5rem);\n}\n.loading__text--fade-in {\n  transition: transform 100ms cubic-bezier(0.4, 0, 0.4, 1), opacity 100ms cubic-bezier(0.4, 0, 0.4, 1);\n  transform: translateY(0);\n  opacity: 1;\n}\n.loading__ball {\n  display: block;\n  width: 0;\n  height: 0;\n  transform-origin: bottom;\n  border-radius: 64px;\n  border: 0.5rem solid rgb(var(--colour-semantic-informative, 0, 88, 163));\n  transition: opacity 200ms cubic-bezier(0.4, 0, 0.4, 1);\n  animation: loading-bounce 0.7s infinite;\n}\n.loading__ball--small {\n  border-width: 0.125rem;\n}\n.loading__ball--medium {\n  border-width: 0.25rem;\n}\n.loading__ball--small, .loading__ball--medium {\n  transform: translateY(-160%);\n  animation: loading-bounce-small 0.7s infinite;\n}\n.loading__ball--large {\n  margin-bottom: 2rem;\n}\n.loading__ball--primary {\n  border-color: rgb(var(--colour-neutral-7, 17, 17, 17));\n}\n.loading__ball--secondary {\n  border-color: rgb(var(--colour-neutral-1, 255, 255, 255));\n}\n.loading__ball--secondary + .loading__text {\n  color: rgb(var(--colour-text-and-icon-5, 255, 255, 255));\n}\n.loading__linear-wrapper {\n  position: relative;\n  display: flex;\n  width: 100%;\n  height: 0.3125rem;\n}\n.loading__linear-wrapper + .loading__text {\n  margin-top: 1rem;\n}\n.loading__sr-only-text, .loading__linear-label {\n  position: absolute;\n  height: 1px;\n  width: 1px;\n  overflow: hidden;\n  clip: rect(1px, 1px, 1px, 1px);\n  margin: -1px;\n  white-space: nowrap;\n}\n.loading__linear-progress {\n  -webkit-appearance: none;\n  appearance: none;\n  width: 100%;\n  height: 100%;\n  border: 0;\n  border-radius: 0.375rem;\n  background: rgb(var(--colour-neutral-2, 245, 245, 245));\n}\n.loading__linear-progress::-webkit-progress-bar {\n  border-radius: 0.375rem;\n  background: rgb(var(--colour-neutral-2, 245, 245, 245));\n}\n.loading__linear-progress::-moz-progress-bar {\n  border-radius: 0.375rem;\n  background: rgb(var(--colour-semantic-informative, 0, 88, 163));\n}\n.loading__linear-progress::-webkit-progress-value {\n  border-radius: 0.375rem;\n  background: rgb(var(--colour-semantic-informative, 0, 88, 163));\n}\n@media (forced-colors: active) {\n  .loading__linear-progress {\n    appearance: revert;\n    height: revert;\n    border: revert;\n    border-radius: revert;\n    background: revert;\n  }\n}\n\n@media (prefers-reduced-motion: reduce) {\n  .loading .loading__text {\n    transition: none;\n  }\n  .loading .loading__ball {\n    transition: none;\n  }\n}\n@keyframes loading-bounce-small {\n  0%, 100% {\n    transform: translate(0, -160%);\n    animation-timing-function: cubic-bezier(0.42, 0, 1, 1);\n  }\n  40% {\n    transform: translate(0, 20%);\n    animation-timing-function: cubic-bezier(0, 0, 0, 1);\n  }\n}\n@keyframes loading-bounce {\n  0% {\n    transform: translateY(0);\n    animation-timing-function: cubic-bezier(0.42, 0, 1, 1);\n  }\n  40% {\n    transform: translateY(2rem) scaleY(1);\n    animation-timing-function: ease-in;\n  }\n  50% {\n    transform: translateY(2rem) scaleY(0.75);\n    animation-timing-function: ease-out;\n  }\n  60% {\n    transform: translateY(2rem) scaleY(1);\n    animation-timing-function: cubic-bezier(0, 0, 0, 1);\n  }\n  100% {\n    transform: translateY(0);\n  }\n}"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
